import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox } from '@wds/checkbox';
import { Table } from '@wds/table';

export default class ReviewsTableHeader extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const {
			allowConflicts,
			canEdit,
			columnHeaders,
			handleSelectAllClick,
			handleSortClick,
			selectedRows,
			rowCount,
			sortDirection,
			sortBy
		} = this.props;

		return (
			<Table.Header>
				<Table.Row>
					<>
						<Table.HeaderCell id={-1} variant="more-actions">
							<Checkbox
								id="sma-js-reviewer-select-all"
								checked={selectedRows.length === rowCount}
								onChange={handleSelectAllClick}
							/>
						</Table.HeaderCell>
						<Table.HeaderCell variant="bulk-actions"></Table.HeaderCell>
						{columnHeaders.map((header, i) => (
							<Table.HeaderCell
								id={i}
								key={i}
								onClick={header.sortable ? e => handleSortClick(e, header) : null}
								isSortable={header.sortable}
								isSorted={header.key == sortBy}
								sortDirection={sortDirection == 'asc' ? 'ascending' : 'descending'}
							>
								{header.label}
							</Table.HeaderCell>
						))}
						{ allowConflicts &&
							<Table.HeaderCell variant="bulk-actions"></Table.HeaderCell>
						}
						{ canEdit &&
							<Table.HeaderCell variant="bulk-actions"></Table.HeaderCell>
						}
						<Table.HeaderCell variant="bulk-actions"></Table.HeaderCell>
						<Table.HeaderCell variant="bulk-actions"></Table.HeaderCell>
					</>
				</Table.Row>
			</Table.Header>
		);
	}
}

ReviewsTableHeader.propTypes = {
	columnHeaders: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		key: PropTypes.string,
		sortable: PropTypes.bool,
	})).isRequired,
	handleSelectAllClick: PropTypes.func,
	handleSortClick: PropTypes.func,
	selectedRows: PropTypes.arrayOf(PropTypes.number),
	rowCount: PropTypes.number,
	sortDirection: PropTypes.string,
	sortBy: PropTypes.string,
	canEdit: PropTypes.bool,
	allowConflicts: PropTypes.bool,
};

ReviewsTableHeader.defaultProps = {
	allowConflicts: false,
	canEdit: false,
	selectedRows: [],
	handleSelectAllClick: null,
	rowCount: 0,
	handleSortClick: () => { },
	sortDirection: 'asc',
	sortBy: '',
};
